import React, { useState, useEffect, useCallback, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

interface Provider {
  id: number;
  name: string;
  is_provider: boolean;
}

interface ProvidersEventProps {
  eventId: number;
  title: string;
  onBack: () => void;
}

const EventoProveedores: React.FC<ProvidersEventProps> = ({ eventId, title, onBack }) => 
{
  const { token } = useContext(AuthContext);

  const [providers, setProviders] = useState<Provider[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  //-----------------------------------------------------------

  // Función para obtener proveedores
  const fetchProviders = useCallback(async () => 
  {
    setLoading(true);
    try 
    {
      const api_url = process.env.REACT_APP_API_BASE_URL || '';
      const response = await fetch(`${api_url}web/get_relation_providers_with_event?id_event=${eventId}`, {
        method: 'GET',
        headers: {
          'X-AUTH-TOKEN': token || ''
        }
      });

      if (response.ok) {
        const data = await response.json();
        setProviders(data);
      } else {
        throw new Error('Error al cargar los proveedores.');
      }
    } 
    catch (error) 
    {
      setError('Error al cargar proveedores.');
    } 
    finally 
    {
      setLoading(false);
    }
  }, [eventId, token]);

  //-----------------------------------------------------------

  // Cargar proveedores cuando cambie el eventId
  useEffect(() => 
  {
    fetchProviders();
  }, [fetchProviders]);

  //-----------------------------------------------------------

  // Manejar el cambio en los checkboxes
  const handleCheckboxChange = (id: number) => 
  {
    setProviders(prevProviders =>
      prevProviders.map(provider =>
        provider.id === id ? { ...provider, is_provider: !provider.is_provider } : provider
      )
    );
  };

  //-----------------------------------------------------------

  // Guardar los cambios
  const handleSave = async () => 
  {
    const selectedProviderIds = providers
      .filter(provider => provider.is_provider)
      .map(provider => provider.id)
      .join('-');

    try 
    {
      const api_url = process.env.REACT_APP_API_BASE_URL || '';
      const response = await fetch(`${api_url}web/update_event_providers`, {
        method: 'POST',
        headers: {
          'X-AUTH-TOKEN': token || '',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          id_event: eventId.toString(),
          ids_providers: selectedProviderIds
        }).toString()
      });

      if (response.ok) 
      {
        onBack();
      } 
      else 
      {
        throw new Error('Error al guardar los cambios.');
      }
    } 
    catch (error) 
    {
      const errorMsg = error instanceof Error ? error.message : 'Error desconocido';
      setError(errorMsg);
    }
  };

  //-----------------------------------------------------------

  return (
    <div className="eventos-container">
      <div className="miguitas">{title}</div>
      <div>
        <div>
          <table>
            <tbody>
              <tr>
                <td>
                  <button onClick={onBack} className="create-client-button">
                    <i className="fas fa-chevron-left"></i> Volver a Eventos
                  </button>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        {loading && <p>Buscando proveedores...</p>}
        {error && <p className="error-message">{error}</p>}
        {!loading && !error && providers.length === 0 && <p>No hay proveedores para mostrar.</p>}
        {!loading && !error && providers.length > 0 && (
          <table className="eventos-table">
            <tbody>
              {providers.map(provider => (
                <tr key={provider.id}>
                  <td className="evento-name">{provider.name}</td>
                  <td className="evento-autonext">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={provider.is_provider}
                        onChange={() => handleCheckboxChange(provider.id)}
                      />
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="pagination-controls">
        <div className="pagination-buttons"></div>
        <div className="pagination-info">
          <button onClick={handleSave}>Guardar</button>
        </div>
      </div>
    </div>
  );
};

export default EventoProveedores;
